import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Card } from "../../../design-system";
import classes from "./DemoReports.module.less";

interface DemoReport {
    id: string;
    name: string;
    type: string;
    description: string;
    generatedAt: string;
}

const DEMO_REPORTS: DemoReport[] = [
    {
        id: "forecast",
        name: "Category Spend and Opportunity Forecast",
        type: "Forecast",
        description:
            "Forward-looking view of category spend with projected savings opportunities and consolidation levers.",
        generatedAt: "May 14, 2026",
    },
    {
        id: "category-analysis",
        name: "Professional Services Consolidation",
        type: "Category Analysis",
        description:
            "Deep-dive analysis of category spend, supplier overlap, and consolidation opportunities.",
        generatedAt: "May 9, 2026",
    },
];

const getDemoReportContentUrl = (reportId: string): string =>
    `/api/project/demo-report/${encodeURIComponent(reportId)}/content`;

export const DemoReportsListView: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Card bordered={false}>
            <div className={classes.header}>
                <div className={classes.title}>Reports</div>
            </div>
            <div className={classes.list}>
                {DEMO_REPORTS.map((report) => (
                    <div
                        key={report.id}
                        className={classes.card}
                        onClick={() => navigate(`/superadmin/demo/reports/${report.id}`)}
                    >
                        <div className={classes.cardType}>{report.type}</div>
                        <div className={classes.cardName}>{report.name}</div>
                        <div className={classes.cardDescription}>{report.description}</div>
                        <div className={classes.cardMeta}>Generated {report.generatedAt}</div>
                    </div>
                ))}
            </div>
        </Card>
    );
};

export const DemoReportDetailView: React.FC = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const report = DEMO_REPORTS.find((r) => r.id === id);

    if (!report) {
        return (
            <Card>
                <p>Report not found.</p>
                <Button onClick={() => navigate("/superadmin/demo/reports")}>
                    Back to Reports
                </Button>
            </Card>
        );
    }

    return (
        <div className={classes.detail}>
            <div className={classes.detailHeader}>
                <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate("/superadmin/demo/reports")}
                >
                    Back to Reports
                </Button>
                <div className={classes.detailTitle}>
                    <span className={classes.detailType}>{report.type}</span>
                    <span className={classes.detailName}>{report.name}</span>
                </div>
            </div>
            <iframe
                className={classes.frame}
                src={getDemoReportContentUrl(report.id)}
                title={report.name}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
        </div>
    );
};
